import { useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import style from "../../styles/inputGrid.module.css";
import "./styles.css";
import { GetTablaGastos } from "../../actions/tablagasto";
import ImagenCerrar from "../../images/cerrar.png";
// const itemsList = [
//   { id: 1, descripcion: "Item A", stock: 10, precio: 100 },
//   { id: 2, descripcion: "Item B", stock: 5, precio: 200 },
//   { id: 3, descripcion: "Item C", stock: 8, precio: 150 },
// ];
export default function ItemForm() {
   
    const navigate = useNavigate();
   const location = useLocation();
   const token = localStorage.getItem("token");
   const { state } = location;
   const itemsList = GetTablaGastos();
   const [inputs, setInputs] = useState({});
   const [cart, setCart] = useState([]);
   const [ttitulo, setTtitulo] = useState("");
   const urlGasto = process.env.REACT_APP_URL_DIR 
   
   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });
   console.log('itemsList: ', itemsList);

   var verInsumo = true
   // eslint-disable-next-line no-unused-vars
   const [input, setInput] = useState({
      id: state ? state.id : 0,
      id_primary: state ? state.id_primary : 0,
      fecha: state ? state.fecha : 0,
      titulo: state ? state.titulo : "",
      total: state ? state.total : 0,
      detalle: state ? state.gastodets : [],      
      hecho:0,
   });
   console.log('state: ', state);
   console.log("input: ", input);
   // Pongo datos de la detalle
   if (input.id_primary > 0 && cart.length === 0 && input.hecho === 0) {
      console.log("input.detalle: ", input.detalle);
      setTtitulo(input.titulo)
      const newcart = input.detalle.map((detalleItem) => {
         const precio = parseFloat(detalleItem.precio);
         console.log('precio: ', precio);
         console.log('descripcion: ', detalleItem.tablagasto.descripcion);
         return {
            id: detalleItem.codigo,
            descripcion: detalleItem.tablagasto.descripcion,
            precio,
         };
      });
      // Populate inputs for each item in newcart
      const newInputs = {};
      newcart.forEach((item) => {
         console.log("item: ", item);
         newInputs[item.id] = {
            amount: item.amount,
            precio: item.precio,
         };
      });
      setInputs(newInputs);
      console.log('newInputs: ', newInputs);

      console.log("newcart: ", newcart);
      setCart(newcart);

      console.log("inputs: ", inputs);
      input.hecho = 1;
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("cart: ", cart);
      const url =
          input.id === 0
             ? urlGasto + "gasto"
             : urlGasto + "gasto/" + input.id;
      const metodo = input.id === 0 ? "POST" : "PUT";
      input.titulo = ttitulo || "Gastos del mes";
      input.total = cart.reduce((acc, item) => acc + item.precio, 0).toFixed(2);
      input.detalle = cart.map((item) => ({
         codigo: item.id,
         precio: item.precio,
      }));
      console.log("input: ", input);
      // console.log("input.total : ", input);
      console.log("url: ", metodo, url);
       fetch(url, {
         method: metodo,
         body: JSON.stringify(input),
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      }).then((res) => res.json());
       input.titulo = "";
       input.total = 0;      
       input.detalle = [];
      window.location.href = "/gasto";
   };

   const handleInputChange = (id, field, value) => {
      const newInputs = {
         ...inputs,
         [id]: {
            ...inputs[id],
            [field]: value,
         },
      };
      setInputs(newInputs);

      const item = itemsList.find((i) => i.id === id);
      const newprecio = parseFloat(newInputs[id]?.precio || item.precio);
      console.log('item: ', item);
      console.log('newprecio: ', newprecio);
         const updatedItem = {
            id,
            descripcion: item.descripcion,
            precio: newprecio 
         };
      const exists = cart.find((c) => c.id === id);
         if (exists) {
            setCart(cart.map((c) => (c.id === id ? updatedItem : c)));
         } else {
            setCart([...cart, updatedItem]);
         }
      
   };

   const removeFromCart = (id) => {
      setCart(cart.filter((item) => item.id !== id));
      setInputs({ ...inputs, [id]: { amount: "", precio: "" } });
   };
   console.log("cart: ", cart);
   return (
      <div className="form-container">
         <div className="list">
            <h2>Gastos</h2>
            <div style={{ marginBottom: 16,backgroundColor: '#f9f9f9', padding: 6, borderRadius: 8 }}>
               <label htmlFor="fecha_gasto" style={{ fontWeight: 600, marginRight: 8 }}>Fecha:</label>
               <input
                  type="date"
                  id="fecha_gasto"
                  value={input.fecha}
                  onChange={e => setInput({ ...input, fecha: e.target.value })}
                  style={{ fontSize: 16, padding: "4px 12px", borderRadius: 6, border: "1px solid #bbb" }}
               />
            </div>
            <table>
               <thead>
                  <tr>
                     <th>Descripcion</th>
                     <th>Observaciones</th>
                     <th>Precio Total</th>
                  </tr>
               </thead>
               <tbody>
                  {itemsList?.map((item) => {                     
                     verInsumo=true
                     if (verInsumo) {
                        return (
                           <tr key={item.id}>
                              <td className={style.tdleft}>
                                 {item.descripcion}
                              </td>
                              <td className={style.tdleft}>
                                 {item.observ}
                              </td>
                              <td className="inputPrecioTd"
                              >
                                 <input 
                                    type="number"
                                    value={inputs[item.id]?.precio || ""}
                                    onChange={(e) =>
                                       handleInputChange(
                                          item.id,
                                          "precio",
                                          e.target.value
                                       )
                                    }
                                 />
                              </td>
                           </tr>
                        );
                     } else {
                        return null;
                     }
                  })}
               </tbody>
            </table>
         </div>

         <div className="list">
            <h2>Gastos Seleccionados</h2>
            <table>
               <thead>
                  <tr>
                     <th colSpan="2">Descripcion</th>
                     <th>Total</th>
                     <th>Accion</th>
                  </tr>
               </thead>
               <tbody>
                  {cart?.map((item) => (
                     <tr key={item.id}>
                        <td colSpan="2" className={style.tdleft}>{item.descripcion}</td>
                        <td className={style.precio}>$&nbsp;{numberFormat.format(item.precio)}</td>
                        <td>
                           <img
                              onClick={() => removeFromCart(item.id)}
                              src={ImagenCerrar}
                              height="30px"
                              alt=""
                           />
                           {/* <button onClick={() => removeFromCart(item.id)}>Remove</button> */}
                        </td>
                     </tr>
                  ))}
                  {cart.length === 0 && (
                     <tr>
                        <td colSpan="5">Seleccione un item</td>
                     </tr>
                  )}
               </tbody>
               {cart.length > 0 && (
                  <>
                     <tr>
                        <td colSpan="2">Total:</td>
                        <td>
                           $&nbsp;
                           {numberFormat.format(cart
                              .reduce((acc, item) => acc + item.precio, 0)
                              .toFixed(2))}
                        </td>
                        <td colSpan="2"></td>
                     </tr>
                     <tr>
                        <td>Descripcion</td>
                        <td colSpan={2}>
                              <input
                                 className={style.inputDescripcion}
                                 type="text"
                                 placeholder="Gasto"
                                 value={ttitulo}
                                 onChange={(e) => setTtitulo(e.target.value)}
                              />
                        </td>
                     </tr>
                     <tr>
                        <td colSpan="1">
                           <button onClick={(e) => handleSubmit(e)}>
                              Grabar
                           </button>
                        </td>
                        <td colSpan="2">&nbsp;</td>
                        <td>
                           <button
                              onClick={() => {
                                 navigate("/Gasto");
                              }}
                           >
                              VOLVER
                           </button>
                        </td>
                     </tr>
                  </>
               )}
            </table>
         </div>
      </div>
   );
}
